import { stationRegionIdSelector } from 'Features/App/Dictionaries/dictionariesSlice';
import { useSelector } from 'react-redux';
import { getPermissionRegion, getPermissionStation, isAdminSelector } from 'Services/auth.service';

export const useIsStationAdmin = (stationId: number) => {
  const isAdmin = useSelector(isAdminSelector);
  const stationRegionId = useSelector(stationRegionIdSelector(stationId));

  // @ts-ignore - точно 2 аргумента (проблемы с селектором ???)
  const regionPermission = useSelector((state) => getPermissionRegion(state, stationRegionId));
  // @ts-ignore - точно 2 аргумента (проблемы с селектором ???)
  const stationPermission = useSelector((state) => getPermissionStation(state, stationId));

  const isStationAdmin = isAdmin || regionPermission?.includes('A') || stationPermission?.includes('A');

  return Boolean(isStationAdmin);
};
